import React from "react";
import {Button, FormCheck, Modal, ModalBody, ModalDialog, ModalFooter, Table} from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";

export default class SuperbillConfirmModal extends React.Component {

    render() {
        let unordered = this.props.unordered;
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            <Modal.Header>Confirm</Modal.Header>
            <Modal.Body>
                The following CNS Order{unordered.length > 1 ? "s were" : " was"} suggested, but {unordered.length > 1 ? "are" : " is"} not being ordered. Please confirm.
                <br/>
                <small><i>If the patient specifically declined the procedure, please check the 'Pt Declined' box next to that procedure.</i></small>
                <br/>
                <Table striped size={"sm"} borderless>
                <thead>
                <tr>
                    <td></td>
                    <td className={"text-center"}>Pt Declined</td>
                </tr>
                </thead>
                <tbody>{unordered.map(o => <tr key={o.orderMetaId}>
                    <td>{o.name}<br/>
                        {o.icds && <ul>{o.icds.map(i => <li key={i.icd10Code}><small>{i.icd10Code} {i.description}</small></li>)}</ul>}
                    </td>
                    <td className={"text-center"}>
                        <FormCheck id={`ptdeclined-${o.orderMetaId}`} name={"declined"} type={"checkbox"} value={"true"} checked={this.props.isOrderPtDeclined(o.orderMetaId)} onChange={e => this.props.toggleOrderPtDeclined(o.orderMetaId, e.target.checked)}/>
                    </td>
                </tr>)}</tbody>
            </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onCancel}>Make Changes</Button>
                <Button variant="dark" onClick={this.props.onConfirm}>Confirm</Button>
            </Modal.Footer>
        </Modal>
    }
}